import { fetchAPI } from '@/lib/api'

export const calculateResponse = async (id: number): Promise<void> => {
  await fetchAPI({
    path: `/forms/${id}/calculate`,
  })
}
